/**
 * Date-extensions locale Serbian [sr]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('sr', {
    monthNames: ['Januar','Februar','Mart','April','Maj','Jun','Jul','Avgust','Septembar','Oktobar','Novembar','Decembar'],
    monthShortNames: ['Jan.','Feb.','Mar.','Apr.','Maj','Jun','Jul','Avg.','Sep.','Okt.','Nov.','Dec.'],
    dayNames: ['Nedelja','Ponedeljak','Utorak','Sreda','četvrtak','Petak','Subota'],
    dayShortNames: ['Ned.','Pon.','Uto.','Sre.','čet.','Pet.','Sub.']
});
